import React from "react"

const tutoriales = {
  barra: {
    title: "Barra de navegación",
    steps: [
      {
        selector: "",
        content: "Bienvenido al Maestro de Programas",
      },
      {
        selector: "#userpicture",
        content:
          "Este es el menú de usuario, desde donde podrá revisar sus permisos y cerrar su sesión.",
      },
      {
        selector: ".periodo",
        content:
          "Este es el período que está revisando. Significa que los cohortes que verá serán los que tengan fecha de inicio en este año. Puede hacer clic en el año para cambiarse de período.",
      },
      {
        selector: ".tour-Cohortes",
        content:
          "En este menú encontrará los cohortes del período para el cual tiene permisos de acceso.",
      },
    ],
  },
  home: {
    title: "Mis Cohortes",
    steps: [
      {
        selector: ".titulo-vista",
        content:
          "En esta página podrás revisar tus cohortes del período indicado en este título.",
      },
      {
        selector: ".periodo",
        content: "Puede hacer clic en el año para cambiar el período.",
      },
      {
        selector: ".misuv",
        content:
          "En esta tabla se muestra el total de cohortes a los que tiene permisos, organizados por Escuela/Facultad y Unidad de Admisión.",
      },
      {
        selector: ".first-unidadventa",
        content:
          "Las Unidades de Admisión son las encargadas de la admisión a los programas.",
      },
      {
        selector: ".first-facultad",
        content:
          "Cada Escuela/Facultad tiene cohortes que son comercializados por las Unidades de Admisión.",
      },
      {
        selector: ".link-facuv",
        content:
          "Al hacer clic en el número podrás revisar el listado de cohortes para esta Escuela/Facultad y Unidad de Admisión.",
      },
      {
        selector: ".crear-cohorte",
        content:
          "Para agregar una nueva cohorte puedes hacer clic en este botón.",
      },
    ],
  },
  "documentos-postulaciones": {
    title: "Documentos de postulaciones",
    steps: [
      {
        content: (
          <p>
            En esta página podrás revisar si los postulantes han subido los
            documentos requeridos para su postulación. Se puede modificar qué
            documentos solicita un cohorte en el{" "}
            <a href="https://fin.uai.cl/Postgrado/admin/">
              Maestro de Programas de Postula
            </a>
            .
          </p>
        ),
      },
      {
        selector: "#cohorteid",
        content: (
          <p>
            En primer lugar debe seleccionar el cohorte que revisará. Solo podrá
            ver cohortes para los que usted posea permisos. Para continuar el
            tour <strong>seleccione un cohorte</strong>
          </p>
        ),
        observe: "#cohorteid",
      },
      {
        selector: ".PostulanteNombre",
        content: (
          <p>En esta columna podrá revisar el nombre y cargo del postulante.</p>
        ),
      },
      {
        selector: ".td-documentos",
        content: (
          <p>
            Cada documento solicitado por el programa se mostrará junto a cada
            postulante.
          </p>
        ),
      },
      {
        selector: ".icono-documento-nok",
        content: (
          <p>
            Un ícono de cuardo vacío denota que el postulante no ha subido aún
            el documento.
          </p>
        ),
      },
      {
        selector: ".icono-documento-ok",
        content: (
          <p>
            Un ícono de cuardo lleno denota que el postulante ya subió el
            documento.
          </p>
        ),
      },
      {
        selector: ".abrir-documento",
        content: (
          <p>
            El enlace "Abrir" permite visualizar el documento subido por el
            postulante.
          </p>
        ),
      },
      {
        selector: "td > input[type='checkbox']",
        content: (
          <p>
            La casilla de la izquierda le permite seleccionar una postulación
            para descargar todos sus documentos.
          </p>
        ),
      },
      {
        selector: "th > input[type='checkbox']",
        content: (
          <p>
            La casilla superior permite seleccionar todos o ninguno de una sola
            vez.
          </p>
        ),
      },
      {
        selector: ".dropdown-seleccionar-postulaciones",
        content: (
          <p>
            El menú junto a la casilla superior le permite seleccionar a todos
            los matriculados.
          </p>
        ),
        observe: ".dropdown-seleccionar-postulaciones",
      },
      {
        selector: ".icono-descargar-carpeta",
        content: (
          <p>
            Una vez seleccionadas las postulaciones, puede descargar todos los
            documentos en un archivo ZIP con este botón.
          </p>
        ),
      },
    ],
  },
  vista: {
    title: "Cohortes",
    steps: [
      {
        content: (
          <p>
            Las listas muestran todas las cohortes para las que tengas permisos,
            organizados por Unidades de Admisión y Escuela/Facultad. Para cada
            cohorte, muestran un conjunto de atributos.
          </p>
        ),
      },
      {
        selector: ".titulo-vista",
        content:
          "Acá se muestra el año académico al que pertenecen las cohortes y el nombre de la lista. El año académico corresponde al año en que se dió inicio a la cohorte, también le llamamos período académico, o simplemente período.",
      },
      {
        selector: ".periodo",
        content:
          "Puedes cambiar el período que estás viendo haciendo clic en el ícono de calendario aquí en la barra superior.",
      },
      {
        selector: ".uai-tabs",
        content:
          "La navegación por etiquetas permite seleccionar una Unidad de Admisión (por ejemplo: Postgrados) y una Escuela/Facultad (por ejemplo: Ingeniería y Ciencias). Al seleccionarlas se mostrarán las cohortes que correspondan.",
      },
      {
        selector: ".tab-fac .active",
        content:
          "Las Unidades de Admisión son las encargadas de la admisión a los programas. La unidad seleccionada se mostrará con un color azul bajo el nombre.",
      },
      {
        selector: ".tab-fac .active .tab-uv .active",
        content:
          "Cada Escuela/Facultad tiene cohortes que son comercializados por las Unidades de Admisión. La E/FAC seleccionada se mostrará con un color azul bajo el nombre.",
      },
      {
        selector: ".switch-tabtype",
        content:
          "Este switch le permite invertir el orden de las etiquetas, i.e. Facultad/Unidad de Admisión o Unidad de Admisión/Facultad.",
      },
      {
        selector: ".numero-cohorte",
        content:
          "Esta columna muestra el número de fila, para facilitar el contar cuántos cohortes hay.",
      },
      {
        selector: ".CohorteId",
        content:
          "La columna ID muestra el código único del cohorte en el sistema, o Borrador cuando el cohorte no ha terminado su proceso de creación.",
      },
      {
        selector: ".borrador",
        content:
          "Los cohortes en estado borrador se destacan con un color diferente.",
      },
      {
        selector: ".menuCohorte",
        position: "top",
        content: (
          <p>
            El ícono de tres puntos permite abrir un menú con acciones a
            realizar con cada cohorte, que se activarán dependiendo de los
            permisos que usted tiene. <strong>Haz clic sobre el menú.</strong>
          </p>
        ),
        observe: ".menuCohorte",
      },
    ],
  },
  reportematriculas: {
    title: "Reporte Postulantes y Matriculados",
    steps: [
      {
        selector: "",
        content: (
          <p>
            El Reporte de Postulantes y Matriculados muestra el avance del
            proceso de admisión para los chortes que usted posea.
          </p>
        ),
      },
      {
        selector: ".modal-fecha-reporte",
        content: (
          <p>
            En el título se marca la fecha en la que fueron actualizadas las
            estadísticas. Se toma una "foto" del avance a las 7pm de cada día.
          </p>
        ),
      },
      {
        selector: ".resumen-matricula",
        content: (
          <>
            <p>
              Las tablas resumen muestran estadísticas agregadas por Unidad de
              Admisión o Escuela/Facultad
            </p>
            <p>
              La tabla superior se muestra el resumen del proceso de admisión,
              mientras que la inferior muestra estadísticas de postulaciones
              retiradas durante el proceso.
            </p>
          </>
        ),
      },
      {
        selector: ".visitantes",
        content: (
          <p>
            Los <strong>visitantes</strong> indican el número de usuarios que
            visitaron las páginas web de los programas.
          </p>
        ),
      },
      {
        selector: ".interesados",
        content: (
          <p>
            Los <strong>interesados</strong> son las personas que solicitaron
            información desde la página web o descargaron el folleto, dejando
            sus datos de contacto.
          </p>
        ),
      },
      {
        selector: ".postulantes",
        content: (
          <p>
            Los <strong>postulantes</strong> son todas las postulaciones que se
            hicieron a los distintos programas.
          </p>
        ),
      },
      {
        selector: ".porentrevistar",
        content: (
          <p>
            <strong>Por entrevistar</strong> es el número de postulantes que
            están a la espera de ser entrevistados por el/la Director/a de
            Programa.
          </p>
        ),
      },
      {
        selector: ".aceptados",
        content: (
          <p>
            <strong>Aceptados</strong> indica los postulantes que ya fueron
            aceptados académicamente y solo falta que paguen su arancel.
          </p>
        ),
      },
      {
        selector: ".matriculados",
        content: (
          <p>
            <strong>Matriculados</strong> son los que ya pagaron su arancel, y
            por ende, poseen un contrato educacional con la Universidad.
          </p>
        ),
      },
      {
        selector: ".matriculados .delta",
        content: (
          <p>
            El porcentaje diferencial es calculado respecto del avance en
            admisión a la misma fecha del año anterior.
          </p>
        ),
      },
    ],
  },
}

export default tutoriales
